import { useTranslation } from 'react-i18next';

import { SVGIconType } from '../../../../constants/svgIcon';
import { AppBar, SvgIcon } from '../../../Molecules';
import {
  SubscriptionCard,
  SubscriptionCardProps,
} from '../../../Molecules/SubscriptionCard';

import styles from './CloudStorageTemplate.module.css';

type CloudStorageTemplateProps = {
  currentPlanProps: SubscriptionCardProps;
};

export const CloudStorageTemplate = ({
  currentPlanProps,
}: CloudStorageTemplateProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <AppBar
        title={t('Cloud Storage')}
        leading={
          <SvgIcon
            name={SVGIconType.Storage}
            width={28}
            height={28}
            color="#333333"
          />
        }
      />
      <div className={styles.list}>
        <SubscriptionCard {...currentPlanProps} />
        {/* Profit Information Section */}
        <div className={styles.profitInfo}>
          <div className={styles.profitIconWrapper}>
            <SvgIcon
              name={SVGIconType.Profits}
              width={54}
              height={54}
              color="#333333"
            />
          </div>
          <div className={styles.profitTextWrapper}>
            {t('50% of our profits will go to charitable causes.')}
          </div>
        </div>
      </div>
    </div>
  );
};
